const investTagRiskLevelLang = {
	'1': {
		tag: 'invest.tag.risk_level.1',
		fr: '1',
		en: '1',
	},
	'2': {
		tag: 'invest.tag.risk_level.2',
		fr: '2',
		en: '2',
	},
	'3': {
		tag: 'invest.tag.risk_level.3',
		fr: '3',
		en: '3',
	},
	'4': {
		tag: 'invest.tag.risk_level.4',
		fr: '4',
		en: '4',
	},
	'5': {
		tag: 'invest.tag.risk_level.5',
		fr: '5',
		en: '5',
	},
};

export default investTagRiskLevelLang;
